import { css } from '@emotion/core';

export default css`
    .humany-lightbox-frame {
        top: 50%;
        max-height: 80%;
        transform: translateY(-50%);
    }
`;
